export default __webpack_public_path__ + "static/header-logo-ciso-1a3850d829052bc55adf377a05b1bf79.png";